// PermissionGuard — wraps route elements to redirect if user lacks view access.
// While permissions are loading, renders nothing (layout skeleton is already visible).

import { Navigate } from 'react-router-dom'
import { useCurrentUser } from '../../hooks/useCurrentUser'
import type { PermissionPage } from '@portico/types'

interface PermissionGuardProps {
  page: PermissionPage
  children: React.ReactNode
}

export function PermissionGuard({ page, children }: PermissionGuardProps) {
  const { canView, isLoading } = useCurrentUser()

  // While loading, show nothing (prevents flash of wrong page then redirect)
  if (isLoading) return null

  // If user cannot view this page, redirect to overview
  if (!canView(page)) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
